<template>
  <div class="menu-container">
    <v-btn icon @click="toggleMenu" aria-label="Toggle category menu">
      <v-icon>{{ menuOpen ? 'mdi-close' : 'mdi-menu' }}</v-icon>
    </v-btn>

    <v-navigation-drawer v-model="menuOpen" temporary fixed class="menu-drawer" :style="{ top: '120px', height: 'calc(100vh - 80px)' }">
      <v-list nav dense>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item
            v-for="(item, index) in menuItems"
            :key="index"
            @click="handleMenuItemClick(item)"
            :disabled="item.disabled || isSelected(item)"
            :class="{
              'menu-item-parent': !item.isSubCategory && item.title !== $t('category.frontPage'),
              selected: isSelected(item),
              disabled: item.disabled,
            }"
          >
            <v-list-item-content>
              <v-list-item-title
                :class="{
                  'text-uppercase': !item.isSubCategory && item.title !== $t('category.frontPage'),
                }"
              >
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue';

export default {
  name: 'CategoryMenu',
  props: {
    menuItems: {
      type: Array,
      default: () => [],
    },
    selectedCategory: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      menuOpen: false,
      selectedItem: null,
    };
  },
  computed: {
    showLandingPage() {
      return this.$store.state.showLandingPage;
    },
    subCategoryDepth() {
      return this.$store.getters.subCategoryDepth;
    },
    categorySelect() {
      return this.$store.getters.getCategorySelectList;
    },
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    handleMenuItemClick(category) {
      if (category) {
        try {
          this.$store.commit('updateCategorySelectIndex', category.uuid);
          this.$store.commit('updateSelectedCategory', category);

          if (category.route && category.route.length) {
            this.$store.commit('updateCurrentTreeLocation', category.route.slice());
          }

          this.$store.commit('updateShowLandingPage', false);
          this.$store.commit('updateShowSubCategoryMenu', category.hasSubCategories);

          if (category.value === '000') {
            this.$store.commit('updateShowLandingPage', true);
            this.$store.commit('updateCategorySelectIndex', null);
            this.$store.commit('updateSelectedCategory', null);
          }
        } catch(err) {
          Sentry.captureException(err, { tags: { component: 'CategoryMenu', category } });
        }
      }

      this.menuOpen = false;
    },
    isSelected(item) {
      return item.uuid === this.selectedCategory;
    },
  },
};
</script>

<style scoped>
.menu-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 40px;
}

.menu-drawer {
  width: 100% !important;
  max-width: 100% !important;
  background-color: white;
  z-index: 2 !important;
}

.menu-drawer :deep(.v-list) {
  padding: 0;
}

.menu-drawer :deep(.v-list-item) {
  min-height: 40px;
  padding: 0 16px;
}

.menu-item-parent {
  margin-top: 16px;
}

.menu-item-indented {
  padding-left: 32px !important;
}

.menu-item-indented .v-list-item__content {
  padding-left: 16px;
}

.selected {
  color: #1b5bdb !important;
  background-color: #d8e3ff;
  font-weight: 500;
  cursor: default;
}

.disabled {
  color: #9d9a9a !important;
  cursor: default;
}

.text-uppercase {
  font-weight: 500;
}
</style>
